import axios from "axios";

export default {
  state: {
    therm: [],
    ext_therm: [],
  },
  getters: {
    get_therm: (state) => {
      return state.therm;
    },
    get_ext_therm: (state) => {
      return state.ext_therm;
    },
    get_therm_warning: (state) => {
      return state.therm.filter(
        (t) => t.isConnected && (t.isBlocked || t.probeError),
      );
    },
    get_external_temp: (state) => {
      if (!state.ext_therm || state.ext_therm.length === 0) return null;
      let valid_temps = state.ext_therm.filter(
        (t) => t.isConnected && !t.probeError,
      );
      if (valid_temps.length === 0) return null;
      let sum = valid_temps.reduce((acc, t) => acc + t.temp_now, 0);
      return sum / valid_temps.length;
    },
  },
  mutations: {
    set_therm(state, therm) {
      state.therm = therm;
    },
    set_ext_therm(state, ext_therm) {
      state.ext_therm = ext_therm;
    },
    set_temp(state, payload) {
      let index = state.therm.findIndex((t) => t.sid === payload.sid);
      if (index !== -1) {
        /*
            'sid': self.sid,
            'temp_now': self.temp_now,
            'nome': self.nome,
            'isConnected': self.isConnected,
            'isBurning': self.isBurning,
            'isBlocked': self.isBlocked,
            'probeError': self.probeError,
            'setpoint': self.setpoint,
            'alarmpoint': self.alarmpoint,
            'last_update': self.last_update,
            'store_interval': self.store_interval,
            'up_time': self.up_time,
            'lit_h': self.lit_h,
            'records': records,
            'enabled': self.enabled,
            'error_rate': self.error_rate,
            'latency': self.latency,
            'local_ip': self.local_ip,
            'external_ip': self.external_ip,
            'RSSI': self.RSSI,
            'SSID': self.SSID,
            'req_time': req_time,
            'position': self.position,
            */
        state.therm[index].temp_now = payload.temp_now;
        state.therm[index].last_update = payload.last_update;
        state.therm[index].isConnected = payload.isConnected;
        state.therm[index].isBurning = payload.isBurning;
        state.therm[index].isBlocked = payload.isBlocked;
        state.therm[index].probeError = payload.probeError;
        state.therm[index].up_time = payload.up_time;
        state.therm[index].error_rate = payload.error_rate;
        state.therm[index].latency = payload.latency;
        state.therm[index].local_ip = payload.local_ip;
        state.therm[index].external_ip = payload.external_ip;
        state.therm[index].RSSI = payload.RSSI;
        state.therm[index].SSID = payload.SSID;
        state.therm[index].enabled = payload.enabled;
        state.therm[index].position = payload.position;
        state.therm[index].lit_h = payload.lit_h;
        state.therm[index].setpoint = payload.setpoint;
        state.therm[index].alarmpoint = payload.alarmpoint;
        state.therm[index].store_interval = payload.store_interval;
        state.therm[index].nome = payload.nome;
        state.therm[index].sid = payload.sid;
        state.therm[index].id = payload.id;
        state.therm[index].req_time = payload.req_time;
        state.therm[index].position = payload.position;
        state.therm[index].pushEnabled = payload.pushEnabled;
        state.therm[index].phoneEnabled = payload.phoneEnabled;
      }
    },
    set_ext_temp(state, ext_therm) {
      let index = state.ext_therm.findIndex((t) => t.sid === ext_therm.sid);
      if (index !== -1) {
        state.ext_therm[index].temp_now = ext_therm.temp_now;
        state.ext_therm[index].last_update = ext_therm.last_update;
        state.ext_therm[index].isConnected = ext_therm.isConnected;
        state.ext_therm[index].probeError = ext_therm.probeError;
        state.ext_therm[index].nome = ext_therm.nome;
        state.ext_therm[index].sid = ext_therm.sid;
        state.ext_therm[index].SSID = ext_therm.SSID;
        state.ext_therm[index].local_ip = ext_therm.local_ip;
        state.ext_therm[index].external_ip = ext_therm.external_ip;
        state.ext_therm[index].RSSI = ext_therm.RSSI;
        state.ext_therm[index].req_time = ext_therm.req_time;
        state.ext_therm[index].store_interval = ext_therm.store_interval;
      }
    },
    remove_thermostat(state, sid) {
      state.therm = state.therm.filter((t) => t.sid !== sid);
    },
  },
  actions: {
    fetch_therm(context) {
      return new Promise((resolve, reject) => {
        let url = process.env.VUE_APP_API_ROOT + "/thermostat";
        let auth = context.getters.get_credential;
        axios
          .get(url, { auth: auth })
          .then((res) => {
            context.commit("set_therm", res.data);
            resolve({ status: 200 });
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    fetch_ext_therm(context) {
      return new Promise((resolve, reject) => {
        let url = process.env.VUE_APP_API_ROOT + "/ext_therm";
        let auth = context.getters.get_credential;
        axios
          .get(url, { auth: auth })
          .then((res) => {
            context.commit("set_ext_therm", res.data);
            resolve({ status: 200 });
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    set_therm_setpoint(context, payload) {
      return new Promise((resolve, reject) => {
        let url = process.env.VUE_APP_API_ROOT + "/thermostat/" + payload.sid;
        let auth = context.getters.get_credential;
        axios
          .post(url, payload, { auth: auth })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    changeThermPosition(context, { sid, newPos }) {
      return new Promise((resolve, reject) => {
        let url =
          process.env.VUE_APP_API_ROOT +
          "/thermostat/" +
          sid +
          "/position/" +
          newPos;
        let auth = context.getters.get_credential;
        axios
          .put(url, {}, { auth: auth })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    changeThermSettings(context, { sid, settings }) {
      return new Promise((resolve, reject) => {
        let url =
          process.env.VUE_APP_API_ROOT + "/thermostat/" + sid + "/settings";
        let auth = context.getters.get_credential;
        axios
          .put(url, settings, { auth: auth })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    deleteThermRecords(context, { sid, ts_fine }) {
      return new Promise((resolve, reject) => {
        let url =
          process.env.VUE_APP_API_ROOT +
          "/thermostat/" +
          sid +
          "/records/inizio/0/fine/" +
          ts_fine;
        let auth = context.getters.get_credential;
        axios
          .delete(url, { auth: auth })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    deleteThermostat(context, { sid }) {
      return new Promise((resolve, reject) => {
        let url = process.env.VUE_APP_API_ROOT + "/thermostat/" + sid;
        let auth = context.getters.get_credential;
        axios
          .delete(url, { auth: auth })
          .then((res) => {
            context.commit("remove_thermostat", sid);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    // WebSocket events

    SOCKET_TEMP_UPDATE(context, payload) {
      context.commit("set_temp", payload);
    },
    SOCKET_EXT_TEMP_UPDATE(context, payload) {
      context.commit("set_ext_temp", payload);
    },
  },
};
